import { graphql } from '~publish/graphql'

export const CustomPostTemplateFields = graphql(`
  fragment CustomPostTemplateFields on PostTemplate {
    id
    title
    body
    description
    emoji
    type
    goal
    structure
    userTypes
    tags
    visibility
    featured
    createdAt
    allowedActions
  }
`)

export const PostTemplatesQuery = graphql(`
  query PostTemplates($input: PostTemplatesInput!, $first: Int) {
    postTemplates(input: $input, first: $first) {
      edges {
        node {
          id
          title
          body
          description
          emoji
          type
          goal
          structure
          userTypes
          tags
          visibility
          featured
          createdAt
        }
      }
    }
  }
`)

export const PublicPostTemplatesQuery = graphql(`
  query PublicPostTemplates($first: Int!, $after: String) {
    publicPostTemplates(input: {}, first: $first, after: $after) {
      edges {
        node {
          id
          title
          body
          description
          emoji
          type
          goal
          tags
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`)

export const MyPostTemplatesQuery = graphql(
  `
    query MyPostTemplates(
      $input: PostTemplatesInput!
      $first: Int
      $after: String
    ) {
      postTemplates(input: $input, first: $first, after: $after) {
        edges {
          node {
            ...CustomPostTemplateFields
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  `,
  [CustomPostTemplateFields],
)

export const CreatePostTemplateMutation = graphql(
  `
    mutation CreatePostTemplate($input: CreatePostTemplateInput!) {
      createPostTemplate(input: $input) {
        ... on CreatePostTemplateSuccess {
          __typename
          postTemplate {
            ...CustomPostTemplateFields
          }
        }
        ... on VoidMutationError {
          __typename
          message
        }
      }
    }
  `,
  [CustomPostTemplateFields],
)

export const UpdatePostTemplateMutation = graphql(
  `
    mutation UpdatePostTemplate($input: UpdatePostTemplateInput!) {
      updatePostTemplate(input: $input) {
        ... on UpdatePostTemplateSuccess {
          __typename
          postTemplate {
            ...CustomPostTemplateFields
          }
        }
        ... on VoidMutationError {
          __typename
          message
        }
      }
    }
  `,
  [CustomPostTemplateFields],
)

export const DeletePostTemplateMutation = graphql(`
  mutation DeletePostTemplate($input: DeletePostTemplateInput!) {
    deletePostTemplate(input: $input) {
      ... on EmptySuccess {
        __typename
      }
      ... on VoidMutationError {
        __typename
        message
      }
    }
  }
`)

export const PostTemplateCampaignsLibraryQuery = graphql(`
  query PostTemplateCampaignsLibrary(
    $input: PostTemplateCampaignsInput!
    $first: Int
  ) {
    postTemplateCampaigns(input: $input, first: $first) {
      edges {
        node {
          id
          slug
          name
          title
          heading
          description
          status
          campaignType
          illustration
          bannerColor
          startDate
          endDate
          toggleTip {
            description
            link
          }
          showTemplatesAfterEndDate
          supportsBanner
          templates {
            id
          }
          createdAt
        }
      }
    }
  }
`)
